import type { VoidFunctionComponent } from 'react';

import { useDebouncedInputValue } from '../../hooks';
import { useLicenses } from '../../hooks/api';
import { selectOptionFactory } from '../../utils';

import { Select } from '.';

const debounceTimeMs = 250;

export type Props = {
  onChange: (licenseId?: string) => void;
};

/**
 * A generic select input for choosing a license from the list of all licenses.
 * Supports debounced searching by title.
 */
const LicenseOptions: VoidFunctionComponent<Props> = ({ onChange }) => {
  const { onChange: updateSearchValue, debouncedValue: debouncedSearchValue } = useDebouncedInputValue(
    '', // Default to an empty string for the initial search value to start with an empty filter.
    debounceTimeMs,
  );

  const licenses = useLicenses(true, { title: debouncedSearchValue, pageSize: 50 });
  const licenseIdOptions = licenses.data?.map((license) => selectOptionFactory(license.licenseId)) ?? [];
  return (
    <Select
      id="ignore-with-exceptions-license-options"
      placeholder="Select a license..."
      options={licenseIdOptions}
      onChange={(licenseId) => onChange(licenseId?.value)}
      onInputChange={(searchValue => updateSearchValue(searchValue))}
      filterOption={null}
    />
  );
};

export default LicenseOptions;
